import { useState, useRef, useEffect, useCallback } from "react";
import {
  Form,
  FormControl,
  FormLabel,
  Button,
  InputGroup,
  Image,
  Row,
  Col,
  Alert,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";
import ApiPath from "../../util/ApiPath";
import ApiUtil from "../../util/ApiUtil";
import SessionUtil from "../../util/SessionUtil";
import Swal from "sweetalert2";
import PhoneInput from "../PhoneInput";
import Func from "../../function/Func";
import ReactLoading from "react-loading";

function FormRegister(props) {
  const { t } = useTranslation(); // Use t instead of lang
  const lang = SessionUtil.getLang();
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [msgErrorEmail, setMsgErrorEmail] = useState();
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [storeNameEn, setStoreNameEn] = useState("");
  const [storeNameAr, setStoreNameAr] = useState("");
  const [srn, setSrn] = useState("");
  const [phone, setPhone] = useState("");
  const [msgErrorPhoneNumber, setMsgErrorPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [addressError, setAddressError] = useState(null);
  const [fileStoreImg, setFileStoreImg] = useState(null);
  const [storeImg, setStoreImg] = useState();
  const [fileCommercialReg, setFileCommercialReg] = useState(null);
  const [commercialRegImg, setCommercialRegImg] = useState();
  const fileInputStoreRef = useRef(null);
  const fileInputCommercialRegRef = useRef(null);
  const [msgError, setMsgError] = useState("");
  const [selectedAreaCode, setSelectedAreaCode] = useState("962");
  const [isValid, setIsValid] = useState(true);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [location, setLocation] = useState([]);
  const navigate = useNavigate();

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setMsgErrorEmail(Func.verifyEmail(value, t));
    setEmail(value);
  };

  const handleStoreImage = (e) => {
    setFileStoreImg(e.target.files[0]);
    const cachedURL = URL.createObjectURL(e.target.files[0]);
    setStoreImg(cachedURL);
  };
  const handleCommercialReg = (e) => {
    setFileCommercialReg(e.target.files[0]);
    const cachedURL = URL.createObjectURL(e.target.files[0]);
    setCommercialRegImg(cachedURL);
  };
  const handleDeleteImg = (type) => {
    if (type === "storeImg") {
      setStoreImg(null);
      setFileStoreImg(null);
      fileInputStoreRef.current.value = "";
    } else {
      setCommercialRegImg(null);
      setFileCommercialReg(null);
      fileInputCommercialRegRef.current.value = "";
    }
  };
  const handleNext = () => {
    setValidated(false);
    if (
      firstName &&
      lastName &&
      email &&
      password &&
      phone &&
      address &&
      selectedLocation
    ) {
      props.setTypeStore("1");
      props.setIsStore(true);
      setCommercialRegImg("");
      setStoreImg("");
      setValidated(false);
    } else {
      validation();
    }
  };

  const validation = () => {
    setValidated(true);
    if (!phone) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
    if (password === "") {
      setPasswordError(false);
    }
    if (address === "") {
      setAddressError(false);
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    validation();
    if (props.type === "3") {
      if (
        fileStoreImg &&
        fileCommercialReg &&
        fileInputStoreRef &&
        fileInputCommercialRegRef &&
        srn &&
        storeNameEn
      ) {
        createStoreApi();
      }
    } else if (firstName && lastName && email && password && phone && address) {
      createUserApi();
    }
  };

  const createUserApi = async () => {
    setLoading(true);
    setPasswordError(null);
    setMsgErrorEmail("");
    setMsgErrorPhoneNumber("");
    setValidated(false);
    let data = {
      FirstName: firstName,
      LastName: lastName,
      Email: email,
      AreaCode: selectedAreaCode,
      PhoneNumber: phone,
      Password: password,
      Address: address,
      Role:
        props.type === "1"
          ? "OPERATION"
          : props.type === "2"
          ? "FINANCIAL"
          : "ADMIN",
      Provider: "WEB",
    };
    const res = await ApiUtil.postApi(ApiPath.CREATE_USER, data, "POST");
    if (res.IsSuccessfull) {
      // create success
      setFirstName("");
      setLastName("");
      setEmail("");
      setPhone("");
      setPassword("");
      setAddress();
      setLoading(false);
      Swal.fire({
        icon: "success",
        text: t("User created successfully"),
        showConfirmButton: false,
        timer: 4000,
      });
      setTimeout(() => {
        navigate("/driver-list", {
          replace: true,
          state: {
            type: props.type,
            username: firstName + " " + lastName,
          },
        });
      }, 4500);
    } else if (!res.IsSuccessfull) {
      handleMsgError(res.Errors[0].Message);
    }
  };

  const createStoreApi = async () => {
    setLoading(true);
    setPasswordError(null);
    setMsgErrorEmail("");
    setMsgErrorPhoneNumber("");
    setValidated(false);
    const formData = new FormData();
    formData.append("LastName", lastName);
    formData.append("Address", address);
    formData.append("StoreNameEn", storeNameEn);
    formData.append("Role", "Store");
    formData.append("PhoneNumber", phone);
    formData.append("AreaCode", selectedAreaCode);
    formData.append("StoreImage", fileStoreImg);
    formData.append("FirstName", firstName);
    formData.append("Password", password);
    formData.append("Email", email);
    formData.append("StoreNameAr", storeNameAr);
    formData.append("CommercialRegisterImage", fileCommercialReg);
    formData.append("StoreLocation", address);
    formData.append("SRN", srn);
    formData.append("StateId", selectedLocation);
    const myHeaders = new Headers();
    myHeaders.append("accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${SessionUtil.getToken()}`);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };

    fetch(`${ApiUtil.baseURL}/${ApiPath.CREATE_STORE}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.IsSuccessfull) {
          setFirstName("");
          setLastName("");
          setEmail("");
          setPhone("");
          setPassword("");
          setAddress();
          setStoreNameEn("");
          setStoreNameAr("");
          setCommercialRegImg("");
          setStoreImg("");
          setSelectedLocation("");
          setLoading(false);
          Swal.fire({
            icon: "success",
            text: t("Store created successfully"),
            showConfirmButton: false,
            timer: 4000,
          });
          setTimeout(() => {
            navigate("/stores-list", { replace: true });
          }, 4500);
        } else if (!result.IsSuccessfull) {
          handleMsgError(result.Errors[0].Message);
          setLoading(false);
        }
      })
      .catch((error) => console.error(error));
  };

  const handleMsgError = (msg) => {
    if (msg === "PHONE_NUMBER_IS_EXIST") {
      setMsgErrorPhoneNumber("PHONE_NUMBER_IS_EXIST");
      setIsValid(false);
      setValidated(false);
      props.setTypeStore("0");
      props.setIsStore(false);
    } else if (msg === "EMAIL_IS_EXIST") {
      setMsgErrorEmail(t("EMAIL_IS_EXIST"));
      props.setTypeStore("0");
      props.setIsStore(false);
    } else {
      setMsgError(msg);
    }
  };
  // Strong password regex: At least 8 characters, one uppercase, one lowercase, one number, one special character
  const passwordRegex = /^.{6,}$/;

  const handlePasswordChange = (e) => {
    const input = e.target.value;
    setPassword(input);
    if (!input) {
      setPasswordError(true); // No error when input is empty
    } else {
      setPasswordError(passwordRegex.test(input) ? null : true);
    }
  };
  const getLocationApi = useCallback(async () => {
    const res = await ApiUtil.getApi(
      ApiPath.LOCATION + "?AreaCode=" + selectedAreaCode
    );
    if (res.IsSuccessfull) {
      setLocation(res.Result);
    }
  }, [selectedAreaCode]);
  useEffect(() => {
    getLocationApi();
  }, [getLocationApi]);

  return (
    <Form
      autoComplete="off"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {props.typeStore === "0" ? (
        <>
          {/* firstName */}

          <Row className="mb-3 g-2">
            <Col xs={12} md={6}>
              <Form.Group controlId="formGroupFirstName">
                <FormLabel className="font-SemiBold">
                  {t("FirstName")}
                </FormLabel>
                <FormControl
                  type="text"
                  name="FirstName"
                  placeholder={t("Enter") + " " + t("FirstName")}
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {t("Please enter") + " " + t("FirstName")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            {/* lastName */}
            <Col xs={12} md={6}>
              <Form.Group controlId="formGroupLastName">
                <FormLabel className="font-SemiBold">{t("LastName")}</FormLabel>
                <FormControl
                  type="text"
                  name="LastName"
                  placeholder={t("Enter") + " " + t("LastName")}
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {t("Please enter") + " " + t("LastName")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          {/* Email */}
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label className="font-SemiBold">{t("Email")}</Form.Label>
            <Form.Control
              type="email"
              name="Email"
              autoComplete="off"
              placeholder={t("Enter") + " " + t("Email")}
              value={email}
              onChange={handleEmailChange}
              required
              isInvalid={!!msgErrorEmail}
            />
            <Form.Control.Feedback
              type={msgErrorEmail !== "" || email === "" ? "invalid" : "valid"}
            >
              {msgErrorEmail
                ? msgErrorEmail
                : t("Please enter") + " " + t("Email")}
            </Form.Control.Feedback>
          </Form.Group>
          {/* password */}
          <Form.Group className="mb-3" controlId="formGroupPassword">
            <Form.Label className="font-SemiBold">{t("Password")}</Form.Label>
            <InputGroup>
              <Form.Control
                name="Password"
                autoComplete="new-password"
                type={showPassword ? "text" : "password"}
                placeholder="**************"
                value={password}
                onChange={handlePasswordChange}
                required
                className={
                  passwordError
                    ? "is-invalid"
                    : passwordError === false
                    ? "is-valid"
                    : ""
                }
              />
              <div
                className={`btn-input-group ${
                  passwordError
                    ? "is-invalid"
                    : passwordError === false
                    ? "is-valid"
                    : ""
                }`}
                onClick={togglePassword}
                style={{ cursor: "pointer" }}
              >
                {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
              </div>

              <Form.Control.Feedback type="invalid">
                {passwordError
                  ? t("Password must be at least 6 characters long")
                  : t("Please enter") + " " + t("Password")}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>

          {/* phone number */}

          <PhoneInput
            phone={phone}
            setPhone={setPhone}
            selectedAreaCode={selectedAreaCode}
            setSelectedAreaCode={setSelectedAreaCode}
            isValid={isValid}
            setIsValid={setIsValid}
            msgErrorPhoneNumber={msgErrorPhoneNumber}
            onClick={() => setSelectedLocation("")}
          />
          {/* selectedLocation */}
          {props.type === "3" && (
            <Form.Group controlId="selectedLocation" className="mb-3">
              <Form.Label className="font-SemiBold">
                {selectedAreaCode === "962" ? t("Governorate") : t("State")}
              </Form.Label>

              <Form.Select
                className={selectedLocation === "" && "first-select-color"}
                onChange={(e) => setSelectedLocation(e.target.value)}
                required
              >
                <option
                  value={selectedLocation ? selectedLocation : ""}
                  className="first-select-color"
                >
                  {selectedAreaCode === "962" ? t("Governorate") : t("State")}
                </option>
                {location.map((item, index) => {
                  return (
                    <option
                      className="option-color"
                      key={index}
                      value={item.Id}
                      onClick={() => getLocationApi()}
                    >
                      {lang === "en" ? item.NameEn : item.NameAr}
                    </option>
                  );
                })}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {t("This field is required")}
              </Form.Control.Feedback>
            </Form.Group>
          )}
          {/* address */}
          <Form.Group className="mb-3" controlId="formGroupAddress">
            <FormLabel className="font-SemiBold">{t("Address")}</FormLabel>
            <InputGroup>
              <div className="position-relative w-100">
                <span className="custome-input-group-text">
                  <FaMapMarkerAlt />
                </span>
                <FormControl
                  type="text"
                  name="Address"
                  className="custome-form-control"
                  placeholder={t("3235 Royal Ln. mesa, new jersy 34...")}
                  value={address}
                  onChange={(e) => {
                    setAddress(e.target.value);
                    if (addressError !== null)
                      e.target.value !== ""
                        ? setAddressError(true)
                        : setAddressError(false);
                  }}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {t("Please enter address")}
                </Form.Control.Feedback>
              </div>
            </InputGroup>
          </Form.Group>
        </>
      ) : (
        <div>
          {/* StoreNameInEnglish */}
          <Form.Group className="mb-3" controlId="StoreNameInEnglish">
            <FormLabel className="font-SemiBold">
              {t("StoreNameInEnglish")}
            </FormLabel>
            <FormControl
              type="text"
              name="StoreNameEn"
              placeholder={t("Enter") + " " + t("StoreNameInEnglish")}
              value={storeNameEn}
              onChange={(e) => setStoreNameEn(e.target.value)}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("Please enter") + " " + t("StoreNameInEnglish")}
            </Form.Control.Feedback>
          </Form.Group>
          {/* StoreNameInArabic */}
          <Form.Group className="mb-3">
            <FormLabel className="font-SemiBold">
              {t("StoreNameInArabic")}
            </FormLabel>
            <FormControl
              type="text"
              name="StoreNameAr"
              placeholder={t("Enter") + " " + t("StoreNameInArabic")}
              value={storeNameAr}
              onChange={(e) => setStoreNameAr(e.target.value)}
              isInvalid={false}
            />
          </Form.Group>
          {/* Srn */}
          <Form.Group className="mb-3">
            <FormLabel className="font-SemiBold">
              {t("Commercial registration number")}
            </FormLabel>
            <FormControl
              type="text"
              name="srn"
              placeholder={
                t("Enter") + " " + t("Commercial registration number")
              }
              value={srn}
              onChange={(e) => setSrn(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="storeImage" className="mb-3">
            <Form.Label className="font-SemiBold">
              {t("Upload Store Image")}
            </Form.Label>
            <Form.Control
              type="file"
              name="StoreImage"
              onChange={handleStoreImage}
              ref={fileInputStoreRef}
              required={fileInputStoreRef}
            />
            {storeImg && (
              <div className="img-preview mt-2 position-relative">
                <Image alt="image" src={storeImg} className="img-fluid" />
                <FaTimes
                  className="delete-icon position-absolute"
                  onClick={() => handleDeleteImg("storeImg")}
                />
              </div>
            )}
            <Form.Control.Feedback type="invalid">
              {t("Please upload image")}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="commercialRegister" className="mb-3">
            <Form.Label className="font-SemiBold">
              {t("Upload Commercial register image")}
            </Form.Label>
            <Form.Control
              type="file"
              name="CommercialRegisterImage"
              onChange={handleCommercialReg}
              ref={fileInputCommercialRegRef}
              required={fileInputCommercialRegRef}
            />
            {commercialRegImg && (
              <div className="img-preview mt-2 position-relative">
                <Image
                  alt="image"
                  src={commercialRegImg}
                  className="img-fluid"
                />
                <FaTimes
                  className="delete-icon position-absolute"
                  onClick={() => handleDeleteImg("commercialRegisterImg")}
                />
              </div>
            )}
            <Form.Control.Feedback type="invalid">
              {t("Please upload image")}
            </Form.Control.Feedback>
          </Form.Group>
        </div>
      )}
      {props.type === "3" && props.typeStore === "0" ? (
        <div
          onClick={handleNext}
          className="btn-main w-100 cursor-pointer py-2 text-center"
        >
          {t("Next")}
        </div>
      ) : (
        <Button
          aria-label="Aria label"
          type="submit"
          className="btn-main w-100"
          disabled={loading}
        >
          <div className="flex-gap-2 justify-content-center">
            {t("Create account")}
            {loading && (
              <ReactLoading
                type={"spin"}
                color={"#c8c8c8"}
                height={"20px"}
                width={"20px"}
              />
            )}
          </div>
        </Button>
      )}

      {msgError !== "" && (
        <Alert variant={"danger"} className="mt-3 py-2">
          {t(msgError)}
        </Alert>
      )}
    </Form>
  );
}

export default FormRegister;
